import posthog from "posthog-js";

let initialized = false;

/** Call after posthog.init() to enable the wrapper. */
export function markAnalyticsReady() {
  initialized = true;
}

const isEnabled = () => initialized;

export const analytics = {
  identify(userId: string, properties?: Record<string, any>) {
    if (isEnabled()) posthog.identify(userId, properties);
  },
  track(event: string, properties?: Record<string, any>) {
    if (isEnabled()) posthog.capture(event, properties);
  },
  reset() {
    if (isEnabled()) posthog.reset();
  },
};
